



































































































































import { Component } from 'vue-property-decorator'
import NotificationSettingsModal from '@/components/notification/partials/NotificationSettingsModal.vue'

// Shared
import TablePagination from '@/components/shared/TablePagination.vue'

// Common
import NotFound from '@/components/common/NotFound.vue'

// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'
import { mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'

// Model
import NotificationSettingsModel from '@/_models/NotificationSettings'
import GeofenceModel from '@/_models/GeofenceModel'

@Component({
  components: {
    NotFound,
    TablePagination,
    NotificationSettingsModal,
  },
  computed: {
    ...mapGetters('notification_settings', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('notification_settings', {
      canDelete: 'canDelete',
    }),
  },
})
export default class NotificationSettings extends mixins(TableSortMixin) {
  // Defined for state functions
  canEdit!: () => boolean
  canDelete!: () => boolean

  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'recipients',
    searchQuery: '',
  }
  numofPage: number = 0

  filedNameLUT: any = {
    recipients: 'label.email',
  }

  selected: NotificationSettingsModel = {}

  isFormModalActive: boolean = false

  get isLoading() {
    return this.$store.state.notification_settings.loading
  }

  get notificationSettings(): NotificationSettingsModel[] {
    return this.$store.state.notification_settings.all.items
  }

  get geofences(): GeofenceModel[] {
    return this.$store.state.geofences.all.items
  }

  get filteredData() {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.notificationSettings) {
      return []
    }

    return this.notificationSettings.filter(item => {
      let itemValue = item[targetField]
      if (typeof itemValue === 'object') {
        itemValue = itemValue.join('-')
      }

      return itemValue.toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1
    })
  }

  targetName(id: string): string {
    const geofence = this.geofences.find((item: GeofenceModel) => item._id === id)

    if (geofence) {
      const targetName = geofence?.name
      const actionsENTER = geofence?.geofence_actions?.enter.length ? 'ENTER' : ''
      const actionEXIT = geofence?.geofence_actions?.exit.length ? 'EXIT' : ''

      if (!actionsENTER && !actionEXIT) {
        return targetName
      } else if (actionsENTER && !actionEXIT) {
        return `${targetName} - ${actionsENTER}`
      } else if (!actionsENTER && actionEXIT) {
        return `${targetName} - ${actionEXIT}`
      } else {
        return `${targetName} - ${actionsENTER} - ${actionEXIT}`
      }
    }

    return ''
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new NotificationSettingsModel()
  }

  handleCloseModal() {
    this.isFormModalActive = false
  }

  handleCopyData(data): void {
    this.isFormModalActive = true
    const { _id, ...contentData } = data
    this.selected = Object.assign({}, contentData)
  }

  confirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  processDelete(data): void {
    this.selected = data
    this.$store.dispatch('notification_settings/deleteOne', this.selected).then(() => {
      this.selected = {}
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  async created() {
    await this.$store.dispatch('notification_settings/getAll')
    await this.$store.dispatch('geofences/getAll')
  }

  beforeDestroy() {
    this.$store.dispatch('resetAllModulesState', ['geofences', 'notification_settings'])
  }
}
